import { render, staticRenderFns } from "./GlyphAutosortButtonGroup.vue?vue&type=template&id=5da759b8&scoped=true"
import script from "./GlyphAutosortButtonGroup.vue?vue&type=script&lang=js"
export * from "./GlyphAutosortButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da759b8",
  null
  
)

export default component.exports